import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Icon from '../Shared/Icon';
import Button from '../Buttons/Button';

const Pod = props => {
    const theme = useTheme();
    const color = theme.palette[props?.color || 'offwhite'].main
    return (
        <Grid item
            className="Pod"
            onClick={props.handler}
            sx={{
                background: theme.palette.offwhite.main,
                color: theme.palette[props.color || "neutral"].main,
                width: props.width || 'auto',
                // border: `2px solid ${color}`,
                '&:hover': {
                    cursor: 'pointer',
                    // background: theme.palette.neutral.main
                }
            }}
        >
            {props.icon && <Icon icon={props.icon} />}

            <Grid item xs sx={{ px: 0.5, overflow: 'hidden' }}>
                {props.children}
            </Grid>

            <Grid>
                {props.launch && <Button type="launch" small handler={props.launch} />}
                {props.refresh && <Button type="refresh" small handler={props.refresh} />}
                {props.delete && <Button type="delete" small handler={props.delete} />}
            </Grid>
        </Grid>
    )
}
export default Pod;